import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core';
import { FieldFeedbackService } from '../../services/field-feedback.service';
import { FeedbackPanelComponent } from '../feedback-panel/feedback-panel.component';
import {
  Feedback,
  UpsertFeedbackComponent,
} from '../upsert-feedback/upsert-feedback.component';

@Component({
  selector: 'h3-upsert-field-feedback',
  imports: [FeedbackPanelComponent, UpsertFeedbackComponent],
  templateUrl: './upsert-field-feedback.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UpsertFieldFeedbackComponent {
  @Input({ required: true }) possibleErrorTags!: string[];

  private readonly fieldFeedbackService = inject(FieldFeedbackService);

  selectedFeedback = this.fieldFeedbackService.getSelectedFeedback();

  close() {
    this.fieldFeedbackService.close();
  }

  save(value: Feedback) {
    this.fieldFeedbackService.save(value);
  }
}
